import { render, staticRenderFns } from "./Patent.vue?vue&type=template&id=44864635&"
import script from "./Patent.vue?vue&type=script&lang=js&"
export * from "./Patent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports